import script from "./TabClasificacionEquipos.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabClasificacionEquipos.vue?vue&type=script&setup=true&lang=ts"

import "./TabClasificacionEquipos.vue?vue&type=style&index=0&id=35091cd7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35091cd7"]])

export default __exports__